/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';
import {
  desktopVW,
} from '../../styles';
import { OptionField } from '../../shared/Inputs';

export const ShippingSelector = ({ data, setReturnShipping } : any) => {
  const handleChange = (e : any) => {
    setReturnShipping(e.target.value);
  };

  return (
    <StyledShippingSelector>
      {/* <OptionField title={data.delivery.title} items={data.delivery.couriers.map((item) => ({ title: item.courier }))} /> */}
      <OptionField onChange={handleChange} title={data.return.title} items={data.return.couriers.map(({ courier } : {courier: string}) => ({ title: courier }))} />
    </StyledShippingSelector>
  );
};

const StyledShippingSelector = styled.div`
  margin-top: ${desktopVW(30)};
  position: relative;
`;
